import { defineStore } from 'pinia'
import { ref } from 'vue'
import { authApi } from '@/api/auth'
import { onUnauthorized, tokenStorage } from '@/api/http'
import type { Owner } from '@/types/domain'

export const useAuthStore = defineStore('auth', () => {
  const user = ref<Owner | null>(null)
  const ready = ref(false)
  const busy = ref(false)

  const clear = () => {
    tokenStorage.clear()
    user.value = null
  }

  onUnauthorized(clear)

  async function restore() {
    if (!tokenStorage.get()) {
      ready.value = true
      return
    }
    try {
      user.value = (await authApi.me()).data
    } catch {
      clear()
    } finally {
      ready.value = true
    }
  }

  async function login(phone: string, password: string) {
    busy.value = true
    try {
      const result = await authApi.login(phone, password)
      tokenStorage.set(result.data.accessToken)
      user.value = result.data.user
    } finally {
      busy.value = false
    }
  }

  async function logout() {
    try {
      if (tokenStorage.get()) await authApi.logout()
    } finally {
      clear()
    }
  }

  return { user, ready, busy, restore, login, logout, clear }
})
